<template>
<v-container>
    <div class="d-flex justify-center align-center flex-column" style="height: 100vh">
        <img width="200" src="/images/logo1.png" alt="logo" class="mb-4">
        <v-progress-circular :width="3" color="primary" indeterminate></v-progress-circular>
    </div>
</v-container>
</template>

<script>
import {
    mapMutations,
    mapActions
} from 'vuex'
export default {
    methods: {
        ...mapMutations(['SnackbarSuccess', 'UserAccount']),
        ...mapActions(['PostResponse', 'GetResponse']),
        async verifyToken() {
            let value = {
                url: '/internal/v2/account/su-login',
                data: {
                    token: this.$route.params.token
                }
            }
            try {
                const data = (await this.PostResponse(value)).data
                if (data.success) {
                    localStorage.setItem("userToken", data.data.token);
                    localStorage.setItem("account", JSON.stringify(data.data.account))
                    localStorage.setItem("user", JSON.stringify(data.data.user))
                    localStorage.setItem("credit", JSON.stringify(data.data.credit))
                    this.UserAccount()
                    this.$router.push('/')
                    this.$root.$emit('LogChange')
                } else {
                    this.$router.push('/')
                }
            } catch (error) {
                this.$router.push('/')
            }
        }
    },
    mounted() {
        this.verifyToken();
    },
}
</script>
